import { retryEnhancer } from '../enhancers/retry/index.js';
import { timeoutEnhancer } from '../enhancers/timeout.js';
import { trackingUuidEnhancer } from '../enhancers/trackingUuid.js';

import type { FetchConfig } from '../types/fetchEnhancer.js';

/**
 * Fetch configured for Babbel's public API Gateway endpoints.
 */
export const fetch = trackingUuidEnhancer(retryEnhancer(timeoutEnhancer(globalThis.fetch)));

/**
 * Possible configuration options for {@link fetch}
 */
export type Config = FetchConfig<typeof fetch>;

export * from '../main.js';
